import React, { useState, useMemo } from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms';
import { themeType } from 'types';

const Header = ({ title, theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoverIcon, setIsHoverIcon] = useState(false);

  const iconColor = useMemo(() => {
    if (isHoverIcon || isOpen) return theme.colors.primary;
    return theme.colors.base;
  }, [isHoverIcon, isOpen, theme.colors.primary, theme.colors.base]);

  return (
    <MenuHeader
      onMouseEnter={() => setIsHoverIcon(true)}
      onMouseLeave={() => setIsHoverIcon(false)}
      onClick={() => setIsOpen(!isOpen)}
    >
      <MenuHeader.Title>{title}</MenuHeader.Title>
      <MenuHeader.Icon>
        <Icon icon="expand-more" color={iconColor} />
      </MenuHeader.Icon>
    </MenuHeader>
  );
};

const MenuHeader = styled.div`
  cursor: pointer;
  font-weight: ${props => props.theme.weight.bold};
  font-size: ${props => props.theme.sizes.m};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing.xs};
  border-radius: ${props => props.theme.values.borderRadius};
`;

MenuHeader.Title = styled.h2`
  margin: 0;
  padding: 0;
  width: 80%;
  font-size: ${props => props.theme.sizes.m};
`;

MenuHeader.Icon = styled.button`
  width: 1fr;
  border: 0;
  background: transparent;
`;

Header.propTypes = {
  title: PropTypes.string.isRequired,
  theme: themeType.isRequired,
};

export default withTheme(Header);
